enum IntegrationID {
  CLASSY = 'classy',
  CONSTANT_CONTACT = 'constant_contact',
  GMAIL = 'gmail',
  IWAVE = 'iwave',
  MAILCHIMP = 'mailchimp',
  OUTLOOK = 'outlook',
  PLEDGE = 'pledge',
  SALESFORCE = 'salesforce',
  STRIPE = 'stripe',
  EVENTBRITE = 'eventbrite',
}

export default IntegrationID;
